/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePracticeBranchDto
 */
export interface CreatePracticeBranchDto {
    /**
     * Branch address
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    address: string;
    /**
     * Street name
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    street: string;
    /**
     * City name
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    city: string;
    /**
     * State name
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    state: string;
    /**
     * ZIP code (5 digits)
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    zip: string;
    /**
     * Branch email address
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    emailAddress: string;
    /**
     * Primary phone number (up to 15 digits)
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    primaryPhoneNumber: string;
    /**
     * Fax number (up to 10 digits, optional)
     * @type {string}
     * @memberof CreatePracticeBranchDto
     */
    faxNumber?: string;
}

/**
 * Check if a given object implements the CreatePracticeBranchDto interface.
 */
export function instanceOfCreatePracticeBranchDto(value: object): value is CreatePracticeBranchDto {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('primaryPhoneNumber' in value) || value['primaryPhoneNumber'] === undefined) return false;
    return true;
}

export function CreatePracticeBranchDtoFromJSON(json: any): CreatePracticeBranchDto {
    return CreatePracticeBranchDtoFromJSONTyped(json, false);
}

export function CreatePracticeBranchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePracticeBranchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'],
        'street': json['street'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'emailAddress': json['emailAddress'],
        'primaryPhoneNumber': json['primaryPhoneNumber'],
        'faxNumber': json['faxNumber'] == null ? undefined : json['faxNumber'],
    };
}

export function CreatePracticeBranchDtoToJSON(json: any): CreatePracticeBranchDto {
    return CreatePracticeBranchDtoToJSONTyped(json, false);
}

export function CreatePracticeBranchDtoToJSONTyped(value?: CreatePracticeBranchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'emailAddress': value['emailAddress'],
        'primaryPhoneNumber': value['primaryPhoneNumber'],
        'faxNumber': value['faxNumber'],
    };
}

